import React from "react";
import { motion } from "framer-motion";

const ChannelCardSkeleton = () => {
  return (
    <div className="h-full rounded-2xl border-2 border-slate-700 bg-slate-900/70 overflow-hidden animate-pulse">
      {/* Header */}
      <div className="p-5 pb-2">
        <div className="flex justify-between items-start gap-2">
          <div className="flex-1">
            <div className="h-5 bg-slate-700 rounded w-3/4 mb-2" />
            <div className="h-3 bg-slate-700/60 rounded w-full" />
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="px-5 pb-4">
        <div className="flex items-center gap-2 mt-2">
          <div className="h-5 w-5 bg-slate-700 rounded-full" />
          <div className="h-4 bg-slate-700 rounded w-20" />
        </div>
        <div className="h-3 bg-slate-700/60 rounded w-32 mt-3" />
      </div>

      {/* Footer */}
      <div className="px-5 pb-5 mt-auto">
        <div className="h-11 bg-slate-700 rounded-md w-full" />
      </div>
    </div>
  );
};

export const ChannelGridSkeleton = ({ count = 3 }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
    {Array.from({ length: count }).map((_, i) => (
      <ChannelCardSkeleton key={i} />
    ))}
  </div>
);

export default ChannelCardSkeleton;
